import { ModalWindow, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import cn from 'classnames';

import { FormModalHeaderLayout } from './FormModalHeaderLayout';
import * as styles from './FormModalLayout.css';
import { ENewReviewStep } from '../../types/newReview';

export type TFormModalLayoutTypes = 'info' | 'form';

interface IFormModalLayoutProps {
  title?: string;
  shortTitle?: string;
  subtitle?: string;
  header?: React.ReactElement | null;
  footer?: React.ReactElement | null;
  type: TFormModalLayoutTypes;
  open: boolean;
  onClose(): void;
  testId: string;
  step?: ENewReviewStep;
}

export const FormModalLayout: React.FC<React.PropsWithChildren<IFormModalLayoutProps>> = ({
  title,
  subtitle,
  children,
  open,
  onClose,
  type,
  shortTitle,
  footer,
  testId,
  step,
}) => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const showBorder = type === 'form';

  return (
    <ModalWindow
      size="M"
      title={isMobile ? shortTitle : undefined}
      header={type === 'info' || isMobile ? null : <FormModalHeaderLayout title={title} subtitle={subtitle} />}
      footer={type === 'info' ? null : footer}
      open={open}
      onClose={onClose}
      width={'100%'}
      height={isMobile ? '100%' : 'auto'}
      maxWidth={644}
      fixed={isMobile}
    >
      <div
        data-testid={testId}
        className={cn(styles['content'], showBorder && styles['border'], styles[`content_step_${step}`])}
      >
        {children}
      </div>
    </ModalWindow>
  );
};
